(function($){
    $(function(){
        makeSticky();

        var $body = $('body'),
            $doc = $(document),
            $header = $('#zn-header'),
            $stickyHeader = $header.find('.zn-sticky.zn-isSticky'),
            $headerSearch = $stickyHeader.find('.zn-search-group'),
            $mainMenuBtn = $('#zn-main-menu-btn'),
            $mainMenu = $('#zn-main-menu'),
            $childNavPanel = $('#zn-child-nav-panel'),
            openClass = 'zn-open',
            openMenu = function(e){
                $body.addClass(openClass + '-menu');
                e.addClass(openClass).attr('aria-expanded', 'true').removeClass('fa-bars').addClass('fa-times');

                $mainMenuBtn.html('Close Menu');

                $doc.on('focusin.menuTabbing', function(e){
                    if ($body.hasClass(openClass + '-menu') && !$.contains($mainMenu.get(0), e.target)){
                        $mainMenuBtn.focus();
                    }
                });
            },
            closeMenu = function(e){
                $body.removeClass(openClass + '-menu');
                $stickyHeader.css('max-height', '');
                e.removeClass(openClass).removeAttr('aria-expanded').removeClass('fa-times').addClass('fa-bars');

                $mainMenuBtn.html('Open Menu');

                $doc.off('focusin.menuTabbing');
            },
            addFocusClass = function(obj, focusClass){
                obj.on('focusin', function(){
                    obj.addClass(focusClass);
                });

                obj.on('focusout', function(){
                    obj.removeClass(focusClass);
                });
            },
            removeFocusClass = function(obj, focusClass){
                obj.off('focusin').off('focusout').removeClass(focusClass);
            },
            buildMobileNav = function(menuLinks) {
                menuLinks.each(function(idx, itm){
                    var $link = $(itm),
                        $panel = $link.next('.zn-sub-menu'),
                        panelID = 'zn-sub-menu-' + idx,
                        expanded = 'zn-expanded';

                    $link.attr('role', 'button').attr('aria-controls', panelID).attr('aria-expanded', 'false');
                    $panel.attr('id', panelID);

                    $link.on('click.mobileNav', function(e){
                        e.preventDefault();

                        $link.attr('aria-expanded', function(index, attr) {
                            return attr === 'true' ? 'false' : 'true';
                        }).toggleClass(expanded);

                        $panel.slideToggle('fast');
                    });
                });
            },
            destroyMobileNav = function(menuLinks) {
                menuLinks.each(function(idx, itm){
                    var $link = $(itm),
                    $panel = $link.next('.zn-sub-menu');

                    $link.off('click.mobileNav').removeClass('zn-expanded');
                    $panel.removeAttr('style');
                });
            },
            buildMegaMenu = function(links, prefix, menuBar) {
                links.each(function(idx, itm) {
                    var $link = $(itm),
                        $panel = $link.next('.zn-sub-menu'),
                        panelID = prefix + '-' + idx,
                        expanded = 'zn-expanded',
                        closePanel = function closePanel() {
                            $link.attr('aria-expanded', 'false').removeClass(expanded).next('.zn-sub-menu').fadeOut('fast');
                            $doc.off('click.megaMenuPanelClick');
                        };

                    $link.attr('role', 'button').attr('aria-controls', panelID).attr('aria-expanded', 'false');
                    $panel.attr('id', panelID);

                    menuBar.on('click.megaMenuClick', function(e) {
                        e.stopPropagation();
                    });

                    $link.on('click.' + prefix, function(e) {
                        e.preventDefault();

                        if (!$link.hasClass(expanded)) {
                            if (links.not($link).hasClass(expanded)) {
                                links.not($link).attr('aria-expanded', 'false').removeClass(expanded).next('.zn-sub-menu').fadeOut('fast');
                            }

                            $link.attr('aria-expanded', 'true').addClass(expanded);
                            $panel.fadeIn('fast');

                            $doc.on('click.megaMenuPanelClick', function() {
                                closePanel();
                            });

                        } else {
                            closePanel();
                        }
                    });
                });
            },
            destroyMegaMenu = function destroyMegaMenu(links, prefix, menuBar) {
                links.each(function(idx, itm) {
                    var $link = $(itm),
                        $panel = $link.next('.zn-sub-menu'),
                        expanded = 'zn-expanded';

                    $link.removeAttr('role').removeAttr('aria-controls').removeAttr('zn-expanded');
                    $panel.removeAttr('id').removeAttr('style');

                    menuBar.off('click.megaMenuClick');
                    $doc.off('click.megaMenuPanelClick');
                    $link.off('click.' + prefix).removeClass(expanded);
                });
            },
            buildChildNav = function(button, panel) {
                button.addAccess().on('click.childNav', function(){
                    button.toggleClass(openClass).attr('aria-expanded', function(index, attr){
                        return attr === 'true' ? 'false' : 'true';
                    });
                    panel.slideToggle('fast');
                });
            },
            destroyChildNav = function(button, panel) {
                button.removeAccess().off('click.childNav').removeClass(openClass).removeAttr('aria-expanded');
                panel.removeAttr('style');
            },
            templateBreaks = [
                {
                    min: 0,
                    max: 1023,
                    enter: function(){
                        $mainMenu.find('.zn-site-search').prependTo($mainMenu.children('.zn-container'));
                        $mainMenu.find('.zn-utility-nav').appendTo($mainMenu.children('.zn-container'));

                        $mainMenuBtn.on('click.mainMenu', function(){
                            if ($mainMenuBtn.hasClass(openClass)){
                                closeMenu($mainMenuBtn);
                            } else {
                                openMenu($mainMenuBtn);
                            }
                        });

                        buildMobileNav($hasMenu);

                        if ($childNavPanel.length) {
                            buildChildNav($childNavPanel.prev('.zn-child-nav-heading'), $childNavPanel);
                        }
                    },
                    exit: function(){
                        $mainMenu.find('.zn-site-search').appendTo($mainMenu.children('.zn-container'));
                        $mainMenu.find('.zn-utility-nav').prependTo($mainMenu.children('.zn-container'));

                        $mainMenuBtn.off('click.mainMenu');
                        closeMenu($mainMenuBtn);

                        destroyMobileNav($hasMenu);

                        if ($childNavPanel.length) {
                            destroyChildNav($childNavPanel.prev('.zn-child-nav-heading'), $childNavPanel);
                        }
                    }
                },
                {
                    min: 1024,
                    max: 99999,
                    enter: function(){
                        buildMegaMenu($hasMenu, 'zn-sub-menu-panel', $mainMenu);
                        addFocusClass($headerSearch, 'focus-within');
                    },
                    exit: function(){
                        destroyMegaMenu($hasMenu, 'zn-sub-menu-panel', $mainMenu);
                        removeFocusClass($headerSearch, 'focus-within');
                    }
                }
            ];

        $mainMenu.find('.zn-sub-menu').prev('.zn-main-link').addClass('zn-has-menu');
        var $hasMenu = $('.zn-has-menu');

        breakdance(templateBreaks);
    });  
})($JQ);